import { render, staticRenderFns } from "./AdAb.vue?vue&type=template&id=71cab917&scoped=true"
import script from "./AdAb.vue?vue&type=script&lang=js"
export * from "./AdAb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cab917",
  null
  
)

export default component.exports